import React from 'react';
import { Control, FieldErrors, UseFormWatch, UseFormSetValue, useFieldArray } from 'react-hook-form';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { FiliationAndMaritalStatusFieldset, ChildrenFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';

interface FamilyStepProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const FamilyStep: React.FC<FamilyStepProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    // useFieldArray para gerenciar children
    const { fields, append, remove } = useFieldArray({
        control,
        name: "children"
    });

    return (
        <div className="p-6">
            <div className="space-y-8">
                <FiliationAndMaritalStatusFieldset
                    context={context}
                    control={control}
                    watch={watch}
                    errors={errors}
                    isSubmitting={isSubmitting}
                />

                <ChildrenFieldset
                    context={context}
                    control={control}
                    errors={errors}
                    isSubmitting={isSubmitting}
                    fields={fields}
                    append={append}
                    remove={remove}
                />
            </div>
        </div>
    );
};

export default FamilyStep;
